import { CardType, OWNED, PINNED_STATUS_NAME } from 'types/deck'

import Icon from 'components/elements/Icon'

import globalVariables from 'assets/scss/variables'

import styles from './pinnedIndicator.module.scss'

type Props = {
  card: CardType
  onAddToPins?: () => void
}

const PinnedIndicator = ({ card, onAddToPins }: Props) => {
  const pinnedColor =
    card.pinnedStatus === OWNED.NO
      ? 'transparent'
      : card.pinnedStatus === OWNED.PRINTING
        ? globalVariables.quantityBlue
        : globalVariables.quantityGreen

  return (
    <button
      className={styles.pinnedSquare}
      onClick={onAddToPins}
      title={`Pinned status: ${PINNED_STATUS_NAME[card.pinnedStatus]}`}>
      {card.pinnedStatus !== OWNED.NO && <Icon name="pin" style={{ color: pinnedColor }} />}
    </button>
  )
}

export default PinnedIndicator
